import PaymentsService from "@api/user/paymentsService";
import {ICumulativeBonus, IDonateBonus} from "@interfaces/user/payments";
import FetchResult from "@models/fetchResult";
import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";

export type IDonateBonusStore = {
    bonuses: IDonateBonus[];
    cumulative?: ICumulativeBonus;
};

const slice = createSlice({
    name: 'donateBonusStore',
    initialState: {
        bonuses: []
    } as IDonateBonusStore,
    reducers: {
        setBonuses: (state, action: PayloadAction<IDonateBonus[]>) => ({
            ...state,
            bonuses: action.payload
        }),
        setBonus: (state, { payload: bonus }: PayloadAction<IDonateBonus>) => {
            const idx = state.bonuses.findIndex(b => b.id === bonus.id);
            if (idx >= 0) {
                state.bonuses[idx] = bonus;
            }
            else {
                state.bonuses.concat(bonus);
            }
        },
        deleteBonus: (state, { payload: id }: PayloadAction<string>) => ({
            ...state,
            bonuses: state.bonuses.filter(b => b.id !== id)
        }),
        setCumulative: (state, { payload: cumulative }: PayloadAction<ICumulativeBonus>) => {
            state.cumulative = cumulative;
        },
    }
});

export const { reducer: donateBonusReducer } = slice;

const {
    deleteBonus,
    setBonus,
    setBonuses,
    setCumulative
} = slice.actions;

export const donateBonusActions = {
    loadAll: () => async (dispatch: Dispatch) => {
        try {
            const api = new PaymentsService();
            const result = await api.getBonuses();
            if(result.success) {
                dispatch(setBonuses(result.data));
            }

            return result;
        } catch (error) {
            return error as FetchResult<IDonateBonus[]>;
        }
    },
    loadBonus: (id: string) => async (dispatch: Dispatch) => {
        try {
            const api = new PaymentsService();
            const result = await api.getBonus(id);

            if(result.success) {
                dispatch(setBonus(result.data));
            }
            else if(result.errorCode === 'BonusNotFound') {
                dispatch(deleteBonus(id));
            }

            return result;
        } catch (error) {
            return error as FetchResult<IDonateBonus>;
        }
    },
    loadCumulative: () => async (dispatch: Dispatch) => {
        try {
            const api = new PaymentsService();
            const result = await api.getCumulativeBonus();

            if(result.success) {
                dispatch(setCumulative(result.data));
            }

            return result;
        } catch (error) {
            return error as FetchResult<ICumulativeBonus>;
        }
    },
    setBonuses
}